document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('ContactForm');

  if (!form) {
    return;
  }

  const submitButton = form.querySelector('[type="submit"]');

  /*
   * Force Shopify CAPTCHA to wire up immediately.
   */
  const setupCaptcha = function () {
    if (
      window.Shopify &&
      window.Shopify.captcha &&
      typeof window.Shopify.captcha.protect === 'function'
    ) {
      window.Shopify.captcha.protect(form);
      return true;
    }

    return false;
  };

  if (!setupCaptcha()) {
    let attempts = 0;

    const waitForCaptcha = setInterval(function () {
      attempts++;

      if (setupCaptcha() || attempts >= 100) {
        clearInterval(waitForCaptcha);
      }
    }, 100);
  }

  /*
   * Do NOT prevent the normal Shopify form submission.
   * Let Shopify's CAPTCHA handler add the token and submit the form.
   */
  form.addEventListener('submit', function () {
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
    }
  });
});